module.exports = __webpack_public_path__ + "fonts/GT-Alpina-Extended-Medium.944e1227.woff";